const config = {
  SSO_BASE_URL: "https://login.microsoftonline.com",
  SSO_GETCODE_PARAMS: {
    client_id: document.env.CLIENT_ID,
    response_type: "code",
    redirect_uri: document.env.REDIRECT_URI,
    scope: "offline_access openid email profile",
    response_mode: "fragment",
    nonce: 678910,
  },
  TENANT: document.env.TENANT,
  // Generative-AI web chat backend (myracle-chatbot).
  CHATBOT_BASE_URL: document.env.CHATBOT_BASE_URL,
  // Scopes used when acquiring a token for the chatbot backend. If
  // CHATBOT_SCOPE isn't configured (same backend/app registration case),
  // fall back to the same scope already used for the main API.
  CHATBOT_SSO_SCOPES: document.env.CHATBOT_SCOPE
    ? [document.env.CHATBOT_SCOPE]
    : ["offline_access openid email profile"],
};

export default config;
